import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "../../Breadcrumb";
// Product images
import HerbalSingleProduct from "./Herbal";
import "../styles.css"

export default function HerbalProduct() {
  return (
    <div className="productPage">
      <div className="container-fluid py-5">
        <div className="row">
          <div className="col-lg-12 herbal">
            <div className="row ">
              <Breadcrumbs currentPathName="Healthy Mix"/>
              <div className="col-md-6">
                <ul className="list-inline shop-top-menu pb-3 pt-1">
                  <li className="list-inline-item">
                    <Link
                      className="h3 text-dark text-decoration-none mr-3 text-uppercase"
                      to="/herbalProduct"
                    >
                      Healthy Mix
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <HerbalSingleProduct />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
